import { Component, Input } from '@angular/core';
import { ProcessedValuePredictorAnswer } from '@fgb/core';

@Component({
  selector: 'fgbcl-answer-counter-predictor-result',
  templateUrl: './answer-counter-predictor-result.component.html',
  styleUrl: './answer-counter-predictor-result.component.scss',
})
export class AnswerCounterPredictorResultComponent {
  @Input() answers: ProcessedValuePredictorAnswer[];
  @Input() multiCounter: boolean = false;
}
